<template>
  <transition name="fade">
    <div class="loading-mask" v-if="active">
      <i class="far fa-spinner-third fa-spin" v-if="spinner"></i>
      <div class="text" v-if="text">{{ text }}</div>
    </div>
  </transition>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class LoadingMask extends Vue {
  @Prop({ required: true })
  active: boolean

  @Prop({ required: false })
  text: string

  @Prop({ required: false, default: true })
  spinner: boolean
}
</script>

<style lang="scss" scoped>
.loading-mask {
  position: absolute;
  z-index: 9;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(#fff, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  color: #494949;

  i {
    font-size: 45px;
  }

  .text {
    font-size: 0.9rem;
    margin-top: 12px;
  }
}
</style>
